import AdminLoginBlock from "../../components/AdminLoginBlock";
import styles from "./adminloginpage.module.css";
import HexagonComponent from "../../components/HexagonComponent";
import HeaderPage from "../../components/HeaderPage";

export default function AdminLoginPage() {
  return (
    <div className={`container-fluid h-custom ${styles.page}`}>
      <HeaderPage />
      <div className={`row my-5 ${styles.logoandloginBlock}`}>
        <div
          className={`col-lg-4 col-xl-4 col-md-6 col-sm-4 ${styles.hexagonlogoContainer}`}
        >
          <HexagonComponent />
        </div>
        <div
          className={`col-lg-4 col-xl-4 col-md-6 col-sm-3 ${styles.loginContainer}`}
        >
          <AdminLoginBlock />
        </div>
      </div>
    </div>
  );
}
